// extracted by mini-css-extract-plugin
export default {"sidebarToggleButton":"ListSidebar-module__sidebarToggleButton__mHnjIja","sidebarHeading":"ListSidebar-module__sidebarHeading__h4fZ7pR","dialog":"ListSidebar-module__dialog__BgIOSyV"};